import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface ImageItem {
	link?: ILink;
	image?: IImage;
}

export interface IImageBarProps extends IBaseElementProps {
	/**
	 * Image Items - Recommended using square images
	 */
	images?: ImageItem[];
}

/**
 * Simple Image Bar
 * @block
 * @icon images-alt
 */
const ImageBar: React.FC<IImageBarProps> = ({
	id,
	className,
	classNames = [],
	images,
}) => {
	if (!Array.isArray(images)) {
		return null;
	}

	return (
		<div
			className={className || cn('image-bar__container', ...classNames)}
			id={id}
		>
			<div className="image-bar__container-inner d-flex flex-wrap justify-content-center gap-3 mw-1240px mx-auto">
				{images.length > 0 &&
					images.map((item, index) => (
						<div
							key={index}
							className="image-bar__image-container overflow-hidden"
						>
							{item.link?.href && (
								<Button {...item.link} className="btn-link">
									<Image
										{...item.image}
										className="d-block mw-100 w-100 h-100 object-fit-cover"
									/>
								</Button>
							)}
							{!item.link?.href && (
								<Image
									{...item.image}
									className="d-block mw-100 w-100 h-100 object-fit-cover"
								/>
							)}
						</div>
					))}
			</div>
		</div>
	);
};

export default ImageBar;
